export default __webpack_public_path__ + "static/media/how-to-use-4.26ab98c5.png";